

import React, { createContext, useEffect, useState } from 'react';

import '../styles/_chiplist.scss';

// $FlowFixMe
export const ChipListContext = createContext();



















export const ChipListV2 = ({
  value,
  onChange,
  multiple = false,
  bgColor,
  bgColorOnSelect,
  iconSize,
  prefix,
  prefixAfterSelect,
  suffix,
  suffixAfterSelect,
  children,
  textColor
}) => {
  const [selection, setSelection] = useState(
    Array.isArray(value) ?
    value
    // $FlowFixMe Flow can't see that null and undefined are filtered out
    : [value].filter((i) => ![null, undefined].includes(i))
  );

  useEffect(() => {
    setSelection(
      Array.isArray(value) ?
      value
      // $FlowFixMe Flow can't see that null and undefined are filtered out
      : [value].filter((i) => ![null, undefined].includes(i))
    );
  }, [value]);

  const onClick = (val) => {
    if (multiple) {
      const sel = selection.includes(val) ?
      selection.filter((i) => i !== val) :
      selection.concat(val);
      setSelection(sel);
      // $FlowFixMe Flow can't see that null and undefined are filtered out
      onChange?.({ value: val, selection: sel }); // eslint-disable-line
    } else {
      const sel = selection.includes(val) ? [] : [val];
      setSelection(sel);
      onChange?.({ // eslint-disable-line
        value: val,
        selection: sel.length > 0 ? sel[0] : undefined
      });
    }
  };

  const context = {
    selection,
    onClick,
    bgColor,
    bgColorOnSelect,
    iconSize,
    prefix,
    prefixAfterSelect,
    suffix,
    suffixAfterSelect,
    textColor
  };

  return (
    <ChipListContext.Provider value={context}>
      <div className="chiplist-wrapper">{children}</div>
    </ChipListContext.Provider>);

};